export default __webpack_public_path__ + "static/media/transfer-epoint-step1.129fa59f.png";